var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDeposited = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_daily_status",
  transform: "translate(-5.036 50.964)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_142",
  "data-name": "Rectangle 142",
  width: 36,
  height: 36,
  transform: "translate(5.036 -50.964)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_876",
  "data-name": "Group 876",
  transform: "translate(6.503 -47.243)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_274",
  "data-name": "Rectangle 274",
  transform: "translate(-0.467 0.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 27,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 32.5,
  height: 25.5,
  rx: 4.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_275",
  "data-name": "Rectangle 275",
  transform: "translate(2.533 3.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 21,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 26.5,
  height: 19.5,
  rx: 1.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_276",
  "data-name": "Rectangle 276",
  transform: "translate(5.533 7.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 12,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 2.5,
  height: 10.5,
  rx: 0.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_279",
  "data-name": "Rectangle 279",
  transform: "translate(2.533 26.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H3A0,0,0,0,1,3,0V.5A1.5,1.5,0,0,1,1.5,2h0A1.5,1.5,0,0,1,0,.5V0A0,0,0,0,1,0,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_280",
  "data-name": "Rectangle 280",
  transform: "translate(27.533 26.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H3A0,0,0,0,1,3,0V.5A1.5,1.5,0,0,1,1.5,2h0A1.5,1.5,0,0,1,0,.5V0A0,0,0,0,1,0,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_281",
  "data-name": "Rectangle 281",
  transform: "translate(27.533 7.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 5,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  height: 4,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_302",
  "data-name": "Rectangle 302",
  transform: "translate(27.533 14.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 5,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  height: 4,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  transform: "translate(12.533 8.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  transform: "translate(15.533 11.278)",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 1.25,
  fill: "none"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDeposited);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_deposited.0aa116d68ca51aa16404fe28b92dd9c2.svg";